import React from "react";
import { Form } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { getSemanticProps } from "../../util";

function CheckboxWidget(props: any) {
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    label,
    autofocus,
    onChange,
    onBlur,
    options,
    onFocus,
    formContext,
  } = props;
  const { t } = useSchemaTranslation();

  const semanticProps = getSemanticProps({ formContext, options });
  const _onChange = (event: any, data: any) => onChange && onChange(data.checked);
  const _onBlur = () => onBlur && onBlur(id, value);
  const _onFocus = () => onFocus && onFocus(id, value);
  const checked = value == "true" || value == true;
  return (
    <Form.Checkbox
      id={id}
      disabled={disabled || readonly}
      autoFocus={autofocus}
      {...semanticProps}
      checked={typeof value === "undefined" ? false : checked}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      required={required}
      label={t(label)}
    />
  );
}

CheckboxWidget.defaultProps = {
  options: {
    semantic: {
      // inverted: false,
    },
  },
};

export default CheckboxWidget;
